import { http } from '@pendo/http';

export function fetchFeedbackAdminSettings (subName) {
    return http
        .get(`/api/super/ss/${subName}/feedback/vendor/adminsettings`, {
            bypassUnauthorizedLogout: true,
        })
        .then((res) => res.data);
}

export function setFeedbackAdminSetting (vendorId, setting, subName, value) {
    return http.put(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/${setting}`, value);
}

export function updateFeedbackAdminSetting (vendorId, setting, subName) {
    return http.post(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/${setting}`);
}

export function updateFeedbackTrial (vendorId, value, subName) {
    return http.post(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/trial`, value);
}

export function fetchFeedbackFeatures (subName) {
    return http
        .get(`/api/super/ss/${subName}/feedback/vendor/features`, {
            bypassUnauthorizedLogout: true,
        })
        .then((res) => res.data);
}

export function updateFeedbackFeature (vendorId, featureKey, featureValue, subName) {
    return http.put(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/features/${featureKey}`, {
        value: featureValue,
    });
}

export function updateFeedbackEmailWhitelabel (subName, vendorId, value) {
    return http
        .put(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/email_whitelabel`, {
            email_from: value,
        })
        .then((res) => res.data);
}

export function toggleFeedbackEmailWhitelabel (subName, vendorId, value) {
    return http
        .put(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/email_whitelabel/toggle`, {
            enabled: `${value}`,
        })
        .then((res) => res.data);
}

export function fetchFeedbackEmailWhitelabel (subName, vendorId) {
    return http
        .get(`/api/super/ss/${subName}/feedback/vendors/${vendorId}/email_whitelabel`, {
            bypassUnauthorizedLogout: true,
        })
        .then((res) => res.data);
}
